import { render, staticRenderFns } from "./cmandang_add.vue?vue&type=template&id=f973268e&scoped=true"
import script from "./cmandang_add.vue?vue&type=script&lang=js"
export * from "./cmandang_add.vue?vue&type=script&lang=js"
import style0 from "./cmandang_add.vue?vue&type=style&index=0&id=f973268e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f973268e",
  null
  
)

export default component.exports